/* unplugin-vue-components disabled */import { render } from "./voiceSelector.vue?vue&type=template&id=2db34200&scoped=true"
import script from "./voiceSelector.vue?vue&type=script&lang=js"
export * from "./voiceSelector.vue?vue&type=script&lang=js"

import "./voiceSelector.vue?vue&type=style&index=0&id=2db34200&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2db34200"]])

export default __exports__